import { Component } from 'react';
import {
  PageHeader,
  Container,
  MobileNav,
  MobileNavItem,
  MobileNavItemLink,
  MobileNavItemIcon,
  MobileNavItemLabel,
  CardTitle,
} from 'ui';
import Breadcrumb from 'components/Breadcrumb';
import { viewportSizes } from 'ui/utils';
import { history } from 'store';
import { MdChevronRight } from 'react-icons/md';
import includes from 'lodash/includes';
import { Box, ButtonReset } from '@tymate/margaret';

export const getWindowWidth = () =>
  Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

export default class MobileRoutes extends Component {
  static defaultProps = {
    links: [],
  };

  constructor(props) {
    super();

    this.state = {
      width: getWindowWidth(),
      redirectionURL: props.redirectionURL,
    };
  }

  componentDidMount() {
    this._isMounted = true;

    this.redirectIfNotOnSmallViewport();
    window.addEventListener('resize', this.handleResizeWindow);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.width !== this.state.width) {
      this.redirectIfNotOnSmallViewport();
    }
  }

  redirectIfNotOnSmallViewport = () => {
    const { width, redirectionURL } = this.state;

    if (width >= viewportSizes.tablet) {
      history.replace(redirectionURL);
    }
  };

  handleResizeWindow = () => {
    if (!this._isMounted) {
      return;
    }

    this.setState({ width: getWindowWidth() });
  };

  renderMobileRoutes = () => {
    const { links, role } = this.props;

    return (
      <MobileNav>
        {links
          .filter(({ allowedFor }) => !allowedFor || includes(allowedFor, role))
          .map(({ url, label, icon, legend, onClick }) => (
            <MobileNavItem key={url}>
              {legend && <p>{legend}</p>}
              <MobileNavItemLink
                to={url}
                as={!Boolean(url) ? ButtonReset : null}
                onClick={onClick}
              >
                {icon && <MobileNavItemIcon children={icon} />}

                <MobileNavItemLabel>{label}</MobileNavItemLabel>

                <MobileNavItemIcon>
                  <MdChevronRight />
                </MobileNavItemIcon>
              </MobileNavItemLink>
            </MobileNavItem>
          ))}
      </MobileNav>
    );
  };

  componentWillUnmount() {
    this._isMounted = false;

    window.removeEventListener('resize', this.handleResizeWindow);
  }

  render() {
    const { hasNoPadding, children, childrenPosition, title, top } = this.props;

    return (
      <>
        <PageHeader>
          <Breadcrumb />
        </PageHeader>

        <Container leftAligned narrow hasNoPadding={hasNoPadding}>
          {top}

          {childrenPosition === 'top' && children}

          {Boolean(title) ? (
            <Box paddingTop={1} paddingBottom={2}>
              <CardTitle>{title}</CardTitle>
              {this.renderMobileRoutes()}
            </Box>
          ) : (
            this.renderMobileRoutes()
          )}

          {childrenPosition !== 'top' && children}
        </Container>
      </>
    );
  }
}
